<div class="organization-payment-and-billing-card">
  <company-block-card
    [title]="'LABELS.PAYMENT_AND_BILLING_SETTINGS'"
    [explanationSubTitle]="'LABELS.ORGANIZATION_PAYMENT_AND_BILLING_SETTINGS_SUBTITLE'"
  >
    <ng-container card-body>
      <!-- Organization monthly payment method -->
      <ng-container *ngIf="isOrganizationAdmin">
        <section class="form-section form-section__separate-block company-payment-method-card" id="company-payment-method-card">
          <loading-spinner [show]="isLoadingPaymentMethods"></loading-spinner>
          <company-payment-method
            addPaymentMethodText="LABELS.ORGANIZATION_ADD_PAYMENT_METHOD"
            [organization]="organization"
            [subscription]="selectedSubscription"
            [isOrganization]="true"
            [allPaymentMethods]="allPaymentMethods"
            [paymentMethods]="paymentMethods"
            [pendingBills]="monthlyBillList"
            [isLoading]="isLoadingPaymentForm"
            [isPayPalPaymentTokenLoading]="isPayPalPaymentTokenLoading"
            (payNow)="payMonthlyBill.emit($event)"
            (deletePayment)="deletePayment.emit($event)"
            (paypalPaymentToken)="paypalPaymentToken.emit()"
            (stripePaymentToken)="stripePaymentToken.emit()"
            (resetSelectedSubscription)="resetSelectedSubscription.emit()"
            *ngIf="!isLoadingPaymentMethods"
          ></company-payment-method>
        </section>
      </ng-container>
      <!-- Organization companies monthly payment method list-->
      <!-- Commented following task: #11011 -->
      <!-- <ng-container *ngIf="isOrganizationAdmin">
        <div
          class="company-payment-existing"
          [ngClass]="{ 'company-payment-existing-selected': isDeletePaymentMethod }"
          *ngFor="let company of companiesWithPaymentMethod"
        >
          <div class="company-payment-existing-left">
            <div class="company-payment-existing-icon">
              <img [src]="getCompanyPaymentMethodIcon(company)" />
            </div>
            <div class="company-payment-existing-text">{{ company.defaultPaymentMethodDescription }}</div>
          </div>

          <div class="company-payment-existing-middle">
            {{ getPaymentMethodCompanyNames(company.defaultPaymentMethodId, company.defaultPaymentMethodDescription) }}
          </div>

          <div class="company-payment-existing-right"></div>
        </div>
      </ng-container> -->

      <!-- Organization plan select-->
      <!-- Commented following task: #13535 -->
      <!-- <organization-plan-select
        [organization]="organization"
        [organizationMembers]="organizationMembers"
        [subscriptions]="organizationSubscriptions"
        (updateSubscription)="updateSubscription.emit($event)"
        (removeSubscription)="removeSubscription.emit()"
      ></organization-plan-select> -->

      <!-- Organization services payment preference card-->
      <ng-container *ngIf="isOrganizationAdmin">
        <organization-services-payment-preference-card
          [organization]="organization"
          [organizationMembers]="organizationMembers"
          (updatePaymentType)="updatePaymentType.emit($event)"
        ></organization-services-payment-preference-card>
      </ng-container>
    </ng-container>
  </company-block-card>
</div>
